import { useState } from 'react'
import { cn } from '@/lib/utils'
import type { ScaleRatingPage } from '@/content/quiz/types'
import { SocialProofBlock } from './SocialProofBlock'

const EMOJI_SCALE = ['😫', '😕', '😐', '🙂', '😊']

interface ScaleRatingQuestionProps {
  page: ScaleRatingPage
  value?: number
  onSelect: (value: number) => void
}

export function ScaleRatingQuestion({ page, value, onSelect }: ScaleRatingQuestionProps) {
  const [hover, setHover] = useState<number | null>(null)
  const range = page.max - page.min + 1
  const displayValue = hover ?? value

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-slate-900">{page.question}</h2>
      <div className="space-y-4">
        <div className="flex justify-between gap-2">
          {Array.from({ length: range }).map((_, i) => {
            const v = page.min + i
            const isSelected = displayValue !== undefined && displayValue === v
            return (
              <button
                key={v}
                type="button"
                onClick={() => onSelect(v)}
                onMouseEnter={() => setHover(v)}
                onMouseLeave={() => setHover(null)}
                className={cn(
                  'flex-1 flex flex-col items-center gap-2 p-4 rounded-xl border-2 transition-all',
                  isSelected ? 'border-sky-300 bg-sky-200' : 'border-slate-200 hover:border-slate-300'
                )}
              >
                {page.useEmoji ? (
                  <span className="text-2xl">{EMOJI_SCALE[i] ?? v}</span>
                ) : (
                  <span className="text-xl font-semibold">{v}</span>
                )}
              </button>
            )
          })}
        </div>
        {page.labels && (
          <div className="flex justify-between text-sm text-slate-500">
            <span>{page.labels.min}</span>
            <span>{page.labels.max}</span>
          </div>
        )}
      </div>
      {page.socialProof && (
        <SocialProofBlock config={page.socialProof} className="mt-8" />
      )}
    </div>
  )
}
